<template>
  <div class="page">
    <van-row type="flex" justify="center">
      <van-col span="22">
        <div>
          <div class="sechout">
            <div class="sech-left" @click="back()">
              <van-icon name="arrow-left" color="#181616" size="20" />
            </div>
            <div class="sech-title">物业信息</div>
            <div class="sech-right"></div>
          </div>
          <div class="content">
            <img class="success" src="../../../../assets/house/property/success.png" alt="">
            <div class="title">支付成功</div>
            <div class="tip">可在“物业管理-缴费记录”里查看该笔支付记录</div>
          </div>
          <div class="btn" @click="toIndex">返回首页</div>
        </div>
      </van-col>
    </van-row>
  </div>
</template>

<script>
  export default {
    methods: {
      back() {
        this.$router.go(-1);
      },
      toIndex() {
        this.$router.push('/house/property/propertyIndex')
      }
    },
  }
</script>

<style lang="less" scoped>
  .page {
    height: 100%;
    background-color: #f5f5f5;
  }

  .sechout {
    padding-top: 22px;
    margin-bottom: 16px;
    height: 44px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .sech-left,
  .sech-right {
    width: 104px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .sech-title {
    font-size: 17px;
    font-weight: 500;
    color: #222325;
  }

  .content {
    background: #FFFFFF;
    border-radius: 6px;
    padding-top: 40px;
    margin-bottom: 20px;
    padding-bottom: 44px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .success {
    width: 81px;
    margin-bottom: 8px;
  }

  .title {
    font-size: 20px;
    font-weight: 600;
    color: #222325;
    line-height: 28px;
    margin-bottom: 12px;
  }

  .tip {
    font-size: 12px;
    font-weight: 400;
    color: #B3B9BF;
    line-height: 17px;
  }

  .btn {
    height: 48px;
    background: #26C165;
    border-radius: 6px;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 48px;
  }
</style>